<div class="password-input-wrapper">
    <input [type]="showPassword ? 'text' : 'password'"
           [id]="id"
           class="password-input"
           [formControl]="inputControl"
           [placeholder]="showPassword ? placeholder : '********'"
           [ngClass]="{ 'password-input-error': isInvalid() || showPasswordMismatch }" />
    @if(!isInvalid() && !showPasswordMismatch) {
        <img [ngSrc]="'/assets/img/icons/' + (showPassword ? 'eye.svg' : 'eye_slash.svg')"
             class="eye-icon"
             (click)="togglePasswordVisibility()"
             priority="true"
             width="14" height="14" alt=""/>
    }
    @if (isInvalid() || showPasswordMismatch) {
        <img [ngSrc]="'/assets/img/icons/red-alarm.svg'" class="alarm-icon"
             width="16" height="16" alt=""/>
        <div class="error-text-wrapper">
            @if (inputControl?.errors?.['required']) {
                <div>{{ subtitles.setSubtitle(5062) }}</div>
            }
            @if (inputControl?.errors?.['minlength']) {
                <div>{{ subtitles.setSubtitle(1147) }}</div>
            }
            @if (showPasswordMismatch) {
                <div>{{ subtitles.setSubtitle(1341) }}</div>
            }
        </div>
    }
</div>
